import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import {
  ONBOARDING_STEP,
  getStepFromPathname,
  isWizardStep,
  onboardingStepPath,
} from "../../constants/onboardingRoutes";

export type OnboardingValidationState = {
  returnTo?: string;
};

/** Redirects unvalidated sessions to validating with the current step as return target. */
export const OnboardingStepGuard = () => {
  const { token } = useParams<{ token: string }>();
  const location = useLocation();
  const tokenValidated = useAppSelector((state) => state.onboarding.tokenValidated);

  if (!token) {
    return <Navigate to="/onboarding-error" replace />;
  }

  if (!tokenValidated) {
    const currentStep = getStepFromPathname(location.pathname);
    const returnTo = isWizardStep(currentStep) ? currentStep : undefined;

    return (
      <Navigate
        to={onboardingStepPath(token, ONBOARDING_STEP.VALIDATING)}
        replace
        state={{ returnTo } satisfies OnboardingValidationState}
      />
    );
  }

  return <Outlet />;
};
